import { NumConversionTypes, toNumber } from './utils.helpers';

export const formatBalance = (balance: NumConversionTypes): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(toNumber(balance));
};

export const parseStr = (str: string | null | undefined): number => {
  if (str === undefined || str === null) return;
  return +(str[0] === '$' ? str.slice(1) : str).replaceAll(',', '');
};

export const parseStrDefaultToZero = (str: string | null | undefined): number => {
  if (str === undefined || str === null) return 0;
  const i = str.indexOf('-');
  if (i === -1) return +(str[i + 1] === '$' ? str.slice(i + 2) : str).replaceAll(',', '');
  if (i === 0)
    return (
      +(str[i + 1] === '$' ? str.slice(i + 2) : str).replaceAll(',', '') * (str[1] === '$' ? -1 : 1)
    );
  return 0;
};
